// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0[data-v-009eda7a] {\n  fill: #23286b;\n}\n.st3[data-v-009eda7a] {\n  fill: #142664;\n}\n.st4[data-v-009eda7a] {\n  fill: #e94766;\n}\n", ""]);
// Exports
module.exports = exports;
